// Pathify
import Vue from 'vue'
import { make } from 'vuex-pathify'
import router from '@/router'

Vue.use(router)

// Data
const state = {
  message: '',
  snackbars: [],
}

const mutations = {
  ...make.mutations(state),
  SET_SNACKBAR (snackbar) {
    state.snackbars = state.snackbars.concat(snackbar)
    // console.log(state.snackbars.filter(s => s.showing))
  },
}

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
  },
  setAlert (context, payload) {
    state.message = payload
  },
  setSnackbar (context, payload) {
    // success, info, warning or error
    payload.type = payload.type || 'success'
    payload.showing = true
    // console.log(payload.text)
    if (state.snackbars.filter(s => s.showing && s.text === payload.text).length === 0) {
      mutations.SET_SNACKBAR(payload)
    }
    // } else {
    //   console.log('duplicate message!!!')
    // }
  },
  clearAllMessage (context, payload) {
    state.snackbars = []
    state.message = ''
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
